export const CHANGE_VIEW_TYPE = 'SHARED/CHANGE_VIEW_TYPE';
export const CHANGE_DEVICE_TYPE = 'SHARED/CHANGE_DEVICE_TYPE';
export const ACTION_TYPES = {
  NOTIFICATION_SHOW: 'NOTIFICATION/SHOW',
  NOTIFICATION_CLOSE: 'NOTIFICATION/CLOSE',
};
